import React from 'react'
import { Box } from 'chemistry'

export default function IframeEmbed({ dataHtml, width, height }) {
  let borderRadius = 0
  if (dataHtml.includes('class="tiktok-embed"')) {
    width = 325
    borderRadius = 8
  }

  const convertWidth = width => `${width % 2 === 0 ? width + 1 : width}px`
  const maxW = width ? convertWidth(width) : '100%'

  return (
    <Box
      borderRadius={`${borderRadius}px`}
      overflow='hidden'
      w='100%'
      maxW={maxW}
      maxH={height ? `${height}px` : '100%'}
      m='0 auto'
      sx={{
        iframe: {
          width: '100%',
          borderRadius: '8px!important',
          margin: '0 auto!important'
        }
      }}
    >
      <Box dangerouslySetInnerHTML={{ __html: dataHtml }} />
    </Box>
  )
}
